import React from 'react';
import Breadcrumbs from 'components/atoms/Breadcrumbs';
import { StyledPageTitle } from 'theme/styles';
import { Grid } from '@mui/material';
import { EButtonVariants } from 'constants/Buttons';
import Button from 'components/atoms/Button';
import { dataFormat } from 'helpers/dataFormat';
import { useNavigate } from 'react-router-dom';
import { ERouteLinks } from 'models/route';
import { useAlert } from 'models/alertContext';
import { Alert } from 'components/atoms/Alert';
import { ActionTypes } from 'state/actions/alert';
import { useTranslation } from 'react-i18next';
import {
  AlertContainer,
  Container,
  ItemLabel,
  ItemValue,
  SectionHeader,
  SectionTitle,
} from './styles';

const data = {
  email: 'john.smith@gmail.com',
  type: 'Individual',
  phone: '+48 606 606 606',
  notification: 'Email, SMS',
  name: 'Mr John James Smith',
  gender: 'Male',
  previousNameAndSurname: '',
  dateOfBirth: '',
  placeOfBirth: '',
  personalId: '',
  identityDocumentType: '',
  documentNumber: '',
  maritalStatus: '',
  nationality: 'English',
  address: '16 The Doles, CB24 5HF Willingham',
  stateProvince: '',
  country: 'United Kingdom',
  homePhone: '',
};

const MyProfilePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { nextPageAlert } = useAlert();

  return (
    <Container>
      {nextPageAlert && (
        <AlertContainer item xs={6}>
          <Alert
            text={nextPageAlert.text}
            variant={nextPageAlert.variant}
            type={ActionTypes.CLEAR_NEXT_PAGE_ALERT}
          />
        </AlertContainer>
      )}
      <Breadcrumbs items={[t('page.myProfile.title')]} />
      <StyledPageTitle variant="h4">{t('page.myProfile.title')}</StyledPageTitle>
      <Grid container xs={12} gap={4}>
        <Grid container item xs={12} gap={2.5}>
          <SectionHeader container item xs={12} gap={2.5}>
            <SectionTitle variant="h5">{t('page.myProfile.accountData')}</SectionTitle>
            <Button
              variant={EButtonVariants.contained}
              label={t('page.myProfile.button.editAccount')}
              sx={{ width: 210 }}
              onClick={() => navigate(ERouteLinks.EditAccountData)}
            />
          </SectionHeader>
          <Grid item container xs={12} columnSpacing={2.5} rowGap={2.5}>
            <Grid item xs={6} md={3}>
              <ItemLabel>{t('page.myProfile.accountData.accountEmail')}</ItemLabel>
              <ItemValue>{dataFormat(data?.email)}</ItemValue>
            </Grid>
            <Grid item xs={6} md={3}>
              <ItemLabel>{t('page.myProfile.accountData.userType')}</ItemLabel>
              <ItemValue>{dataFormat(data?.type)}</ItemValue>
            </Grid>
            <Grid item xs={6} md={3}>
              <ItemLabel>{t('page.myProfile.accountData.mobilePhone')}</ItemLabel>
              <ItemValue>{dataFormat(data?.phone)}</ItemValue>
            </Grid>
            <Grid item xs={6} md={3}>
              <ItemLabel>{t('page.myProfile.accountData.notificationChannels')}</ItemLabel>
              <ItemValue>{dataFormat(data?.notification)}</ItemValue>
            </Grid>
          </Grid>
        </Grid>
        <Grid container item xs={12} gap={2.5}>
          <SectionHeader container item xs={12} gap={2.5}>
            <SectionTitle variant="h5">{t('page.myProfile.personalData')}</SectionTitle>
            <Button
              variant={EButtonVariants.contained}
              label={t('page.myProfile.button.edit')}
              sx={{ width: 95 }}
            />
          </SectionHeader>
          <Grid item container xs={12} columnSpacing={2.5} rowGap={2.5}>
            <Grid item xs={6} md={3}>
              <ItemLabel>{t('page.myProfile.personalData.nameAndSurname')}</ItemLabel>
              <ItemValue>{dataFormat(data?.name)}</ItemValue>
            </Grid>
            <Grid item xs={6} md={3}>
              <ItemLabel>{t('page.myProfile.personalData.gender')}</ItemLabel>
              <ItemValue>{dataFormat(data?.gender)}</ItemValue>
            </Grid>
            <Grid item xs={6} md={3}>
              <ItemLabel>{t('page.myProfile.personalData.previousNameAndSurname')}</ItemLabel>
              <ItemValue>{dataFormat(data?.previousNameAndSurname)}</ItemValue>
            </Grid>
            <Grid item xs={6} md={3}>
              <ItemLabel>{t('page.myProfile.personalData.dateOfBirth')}</ItemLabel>
              <ItemValue>{dataFormat(data?.dateOfBirth)}</ItemValue>
            </Grid>
            <Grid item xs={6} md={3}>
              <ItemLabel>{t('page.myProfile.personalData.placeOfBirth')}</ItemLabel>
              <ItemValue>{dataFormat(data?.placeOfBirth)}</ItemValue>
            </Grid>
            <Grid item xs={6} md={3}>
              <ItemLabel>{t('page.myProfile.personalData.nationality')}</ItemLabel>
              <ItemValue>{dataFormat(data?.nationality)}</ItemValue>
            </Grid>
            <Grid item xs={6} md={3}>
              <ItemLabel>{t('page.myProfile.personalData.personalId')}</ItemLabel>
              <ItemValue>{dataFormat(data?.personalId)}</ItemValue>
            </Grid>
            <Grid item xs={6} md={3}>
              <ItemLabel>{t('page.myProfile.personalData.identityDocumentType')}</ItemLabel>
              <ItemValue>{dataFormat(data?.identityDocumentType)}</ItemValue>
            </Grid>
            <Grid item xs={6} md={3}>
              <ItemLabel>{t('page.myProfile.personalData.documentNumber')}</ItemLabel>
              <ItemValue>{dataFormat(data?.documentNumber)}</ItemValue>
            </Grid>
            <Grid item xs={6} md={3}>
              <ItemLabel>{t('page.myProfile.personalData.maritalStatus')}</ItemLabel>
              <ItemValue>{dataFormat(data?.maritalStatus)}</ItemValue>
            </Grid>
          </Grid>
        </Grid>
        <Grid container item xs={12} gap={2.5}>
          <SectionHeader container item xs={12} gap={2.5}>
            <SectionTitle variant="h5">{t('page.myProfile.homeAddress')}</SectionTitle>
            <Button
              variant={EButtonVariants.contained}
              label={t('page.myProfile.button.edit')}
              sx={{ width: 95 }}
            />
          </SectionHeader>
          <Grid item container xs={12} columnSpacing={2.5} rowGap={2.5}>
            <Grid item xs={6} md={3}>
              <ItemLabel>{t('page.myProfile.homeAddress.homeAddress')}</ItemLabel>
              <ItemValue>{dataFormat(data?.address)}</ItemValue>
            </Grid>
            <Grid item xs={6} md={3}>
              <ItemLabel>{t('page.myProfile.homeAddress.stateProvince')}</ItemLabel>
              <ItemValue>{dataFormat(data?.stateProvince)}</ItemValue>
            </Grid>
            <Grid item xs={6} md={3}>
              <ItemLabel>{t('page.myProfile.homeAddress.country')}</ItemLabel>
              <ItemValue>{dataFormat(data?.country)}</ItemValue>
            </Grid>
            <Grid item xs={6} md={3}>
              <ItemLabel>{t('page.myProfile.homeAddress.homePhoneNumber')}</ItemLabel>
              <ItemValue>{dataFormat(data?.homePhone)}</ItemValue>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export { MyProfilePage };
